import { TFunction } from 'i18next';
import * as yup from 'yup';

export const getSignInSchema = (t: TFunction) =>
    yup.object({}).shape({
        email: yup.string().email(t('form:invalidEmail')).required(t('form:requiredField')),
        password: yup.string().required(t('form:requiredField')),
    });
